$(document).ready(function(){
// *** START bundle-builder-popup
  const currentURL = window.location.href; // Get the current URL
  const targetPath = "/bijou-build"; // Target path
  const $popup = $(".bundle-builder--popup"); // Popup element
  const $popupWrapper = $(".bundle-builder-popup-wrapper"); // Wrapper element
  const $bundlePopupWrapper = $(".bundle-builder-popup"); // Wrapper element

  // $(document).on("click", ".upsell_modal .modal_btn", function () {
  // $(document).on("click", '#upsell-modal > button', function (){
  //   // if (currentURL.includes(targetPath)) {
  //     $popup.find(".popup-overlay").addClass("active");
  //     $popup.find(".bundle-builder-popup-wrapper").addClass("active");
  //     $("body,html").addClass('overflow-hidden');
  //     initializeSlickSlider();
  //   // }
  // });

 
  // function initializeSlickSlider() {
  //   $('.popup-product-popup').slick({
  //       dots: true,
  //       infinite: false,
  //       speed: 300,
  //       slidesToShow: 2,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       responsive: [
  //           {
  //               breakpoint: 1024,
  //               settings: {
  //                   slidesToShow: 2,
  //                   slidesToScroll: 1,
  //                   infinite: true,
  //                   dots: true
  //               }
  //           },
  //           {
  //               breakpoint: 992,
  //               settings: {
  //                   slidesToShow: 2,
  //                   slidesToScroll: 1,
  //                   infinite: true,
  //                   dots: true
  //               }
  //           },
  //           {
  //               breakpoint: 768,
  //               settings: {
  //                   slidesToShow: 2,
  //                   slidesToScroll: 1
  //               }
  //           }
  //       ]
  //   });
  // }
  // function initializeUpsellSlickSlider() {
  //   $('.upsell-product-slider').slick({
  //       dots: true,
  //       infinite: false,
  //       speed: 300,
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false,
  //       responsive: [
  //         {
  //           breakpoint: 1024,
  //           settings: {
  //               slidesToShow: 1,
  //               slidesToScroll: 1,
  //               infinite: true,
  //               dots: true
  //             }
  //         },
  //         {
  //           breakpoint: 992,
  //           settings: {
  //               slidesToShow: 1,
  //               slidesToScroll: 1,
  //               infinite: true,
  //               dots: true
  //           }
  //         },
  //         {
  //           breakpoint: 768,
  //           settings: {
  //               slidesToShow: 1,
  //               slidesToScroll: 1
  //           }
  //         }
  //       ]
  //   });
  //  }
  
  $(document).on("click",".popup-overlay",function(){
    $(this).removeClass("active");
    $(this).closest(".bundle-builder--popup").find(".bundle-builder-popup-wrapper").removeClass("active");
    $("body,html").removeClass("overflow-hidden");
  });


   // globally declared variable
  let bundleVariants = [];
  let currentIndex = 0;
  let totalPrice = 0;
  let totalComparePrice = 0;
  let dataCurrency = $("body").attr("data-currency");
  const maxPrice = 1800;
  const milestones = [
    { threshold: 900, class: "popup-milestone-one" },
    { threshold: 1300, class: "popup-milestone-two" },
    { threshold: 1800, class: "popup-milestone-three" },
  ];
  
  // *** Start Update the popup list with a new item.
  function updatePopupList(element, imageSrc, productPrice, productComparePrice) {
    var updatePopupVariantId = element.attr("data-variantid");
    var updatePopupTitle = element.attr("data-product-title");
    var updatePopupPrice = element.attr("data-product-price");
    var updatePopupComparePrice = element.attr("data-product-compare-price");
    const comparePriceHTML = productComparePrice ? `<span class="popup-product-compare-price">${dataCurrency + productComparePrice}</span>` : "";
    const popupItem = `
      <li class="popup-product-item" data-variant-id="${updatePopupVariantId}" data-title="${updatePopupTitle}" data-price="${updatePopupPrice}" data-compare-price="${updatePopupComparePrice}">
        <div class="popup-product-content-wrapper" >
          <span class="product-item-close bundle-popup-close-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M7.42111 8.79347L4.64517 6.01752L1.88994 8.77275L0.72984 7.61265L3.48507 4.85742L0.72984 2.10219L1.90375 0.928284L4.65898 3.68351L7.41421 0.928284L8.57431 2.08838L5.81908 4.84361L8.59502 7.61956L7.42111 8.79347Z" fill="black"/></svg>
          </span>
          <span class="quantity-add-remove"></span>
          <div class="popup-product-content-image"><img src="${imageSrc}"></div>
          <div class="popup-product-add-title">${updatePopupTitle}</div>
          <div class="compare-price-and-price">
            <span class="popup-product-price">${dataCurrency + productPrice}</span>
            ${comparePriceHTML}
          </div>
        </div>
      </li>`;
    $(".product_item_add").append(popupItem);
  }
  // **** END Update the popup list with a new item.

  // *** START Add product item price function
  function addPrice(element, productPrice) {
    var numericPrice = parseFloat(productPrice.replace(/[^0-9.-]+/g, ""));
    totalPrice += numericPrice;
    updateUI()
    // $("#popup-current-amount").text(dataCurrency + totalPrice.toFixed(2));
    // $(".popup-total-price").text(dataCurrency + totalPrice.toFixed(2));
    // $(".checkout-button-price").text(dataCurrency + totalPrice.toFixed(2));
  }
  // *** END Add product item price function
  
  // *** START Add product item price function
  function addComparePrice(element, productComparePrice) {
    var numericComparePrice = parseFloat(productComparePrice.replace(/[^0-9.-]+/g, ""));
    totalComparePrice += numericComparePrice;
    if (totalComparePrice > 0) {
      $(".total-compare-price").text(totalComparePrice.toFixed(2)).show();
    } else {
      $(".total-compare-price").hide();
    }
  }
  // *** END Add product item price function

  // *** START Update Progress Bar
  function updateProgressBar() {
    const progressPercentage = Math.min((totalPrice / maxPrice) * 100, 100);
    $(".popup-progress-bar").animate({ width: progressPercentage + "%" }, 500);
    $(".popup-milestone").removeClass("active");
    milestones.forEach((milestone, index) => {
      if (totalPrice >= milestone.threshold) {
        $("." + milestone.class).addClass("active");
        $(".popup-progress-bar-wrapper--content").find(".popup-progress-bar").css("background", getBackgroundColorForMilestone(milestone.class));
        if (index > 0) {
          $("." + milestones[index - 1].class).removeClass("active");
        }
      }
    });
    if (totalPrice < milestones[0].threshold) {
      $(".popup-progress-bar-wrapper--content").find(".popup-progress-bar").css("background", getBackgroundColorForMilestone("default")); // Set to default color
    }
  }

  // Function to return background color based on milestone class
  function getBackgroundColorForMilestone(milestoneClass) {
    switch (milestoneClass) {
      case "popup-milestone-one":
        $(".popup-save-text, .save-price-text").css("display","flex");
        $(".popup-save-peice, .price-text").text("5%");
        // return "linear-gradient(90deg, #E1B9A9 0%, #DBB3A3 100%)";
        return "#309388";
      case "popup-milestone-two":
        $(".popup-save-text, .save-price-text").css("display","flex");
        $(".popup-save-peice, .price-text").text("10%");
        // return "linear-gradient(90deg, #EEE 0%, #F0F0F0 100%)";
        return "#309388";
      case "popup-milestone-three":
        $(".popup-save-text, .save-price-text").css("display","flex");
        $(".popup-save-peice, .price-text").text("15%");
        // return "linear-gradient(90deg, #F2EBD3 0%, #F5EED6 100%)";
        return "#309388";
      default:
        $(".popup-save-text, .save-price-text").css("display","none");
        return "#309388";
    }
  }
  // *** END Update Progress Bar

  // *** START Remove product item price function
  function removePrice(element) {
    // var priceToRemove = parseFloat(
    //   element.closest(".popup-product-item").attr("data-price").replace(/[^0-9.-]+/g, "")
    // );
    // totalPrice -= priceToRemove;
    // $("#popup-current-amount").text(dataCurrency + totalPrice.toFixed(2));
    // $(".popup-total-price").text(dataCurrency + totalPrice.toFixed(2));
    // $(".checkout-button-price").text(dataCurrency + totalPrice.toFixed(2));


    let removeVariantId = element.closest(".popup-product-item").attr("data-variant-id");

    let removeArrayPrice =  bundleVariants.find(item => item.variantID === removeVariantId);
    
    if (removeArrayPrice) {
      totalPrice -= removeArrayPrice.productTotalPrice;
      totalPrice = Math.max(totalPrice, 0);

      removeArrayPrice.productTotalPrice = 0;

      $("#popup-current-amount").text(dataCurrency + totalPrice.toFixed(2));
      $(".popup-total-price").text(dataCurrency + totalPrice.toFixed(2));
      $(".checkout-button-price").text(dataCurrency + totalPrice.toFixed(2));

      console.log("Updated totalPrice:", totalPrice);
    }
  }
  // *** END Remove product item price function
  
  // *** START Remove product item price function
  function removeComparePrice(element) {
    var comparePriceToRemove = parseFloat(
      element.closest(".popup-product-item").attr("data-compare-price").replace(/[^0-9.-]+/g, "")
    );
    totalComparePrice -= comparePriceToRemove;
    $(".total-compare-price").text(totalComparePrice.toFixed(2));
  }
  // *** END Remove product item price function

  // Prepare the data payload
  // function ajaxCheckoutJS() {
  //   const payload = {
  //     items: bundleVariants.map((variant) => ({
  //       id: parseInt(variant.variantID, 10), // Ensure variant ID is an integer
  //       // quantity: 1, // Default to 1 if quantity is not provided
  //       quantity: parseInt(variant.quantity, 10) || 1,
  //     })),
  //   };
  //   // Send the POST request
  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(payload),
  //   })
  //     .then((response) => {
  //       if (!response.ok) {
  //         throw new Error("Failed to add products to the cart");
  //       }
  //       return response.json();
  //     })
  //     .then((data) => {
  //       console.log("Products added to the cart:", data);
  //     })
  //     .catch((error) => {
  //       console.error("Error adding products to the cart:", error);
  //     })
  //     .finally(() => {
  //       bundleVariants = [];
  //     });
  // }

  function ajaxCheckoutJS() {
    // Hide the UpCart drawer before adding items
    $(".upcart-cart, .styles_CartPreview__backdrop__").attr("style", "display: none !important;");
    
    const payload = {
        items: bundleVariants.map(variant => ({
            id: parseInt(variant.variantID, 10),
            quantity: parseInt(variant.quantity, 10) || 1,
        })),
    };

    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var parsedState = JSON.parse(xhr.responseText);
            console.log("Products added to the cart:", parsedState);
            window.location.href = "/checkout";
        }
    };

    xhr.send(JSON.stringify(payload));
  }

  //*** START Ajax cart click event
  $(document).on("click", ".popup-ajax-add-to-cart", function () {
    const closestWrapper = $(this).closest(".popup-product-list-wrapper-with-content");
    const imageSrc = closestWrapper.find("img").attr("src");
    const productPrice = $(this).attr("data-product-price");
    const productComparePrice = $(this).attr("data-product-compare-price");
    const productTitle = $(this).attr("data-product-title");
    addPrice($(this), productPrice);
    addComparePrice($(this), productComparePrice);
    const variantDetails = {
      variantID: $(this).attr("data-variantid"),
      productTitle: $(this).attr("data-product-title"),
      quantity: 1,
      productTotalPrice: parseFloat($(this).attr("data-product-price")) || 0
    };
    bundleVariants.push(variantDetails);
    console.log("bundleVariants ",bundleVariants)
    updatePopupList($(this), imageSrc, productPrice, productComparePrice);
    updateProgressBar();
    $(".popup-edit-button").css("display","flex");
    $(".popup-next-step-button").css({"pointer-events":"auto","opacity":"1"});
    setTimeout(function(){
      suggestionText();
    }, 100)
    
    var $this = $(this);
    $this.find(".add-button").addClass("active");
    $this.find(".loading-button").addClass("active");
    setTimeout(function(){
      $this.find(".add-button").removeClass("active");
      $this.find(".loading-button").removeClass("active");
    },1000)


    // **Quantity add logic**
    const $quantityInput = closestWrapper.find(".select-quantity input");
    let quantity = parseInt($quantityInput.val()) || 0;
    var newQuantity = quantity + 1;
    // **Update both value & attr("value")**
    $quantityInput.val(newQuantity).attr("value", newQuantity).trigger("change");
    
    var $stickyItem = $(".popup-product-item[data-variant-id='" + $(this).attr("data-variantid") + "']");
    if ($stickyItem.length) {
        $stickyItem.find(".quantity-add-remove").text(newQuantity);
    }

    // **Hide 'ajax-add-to-cart' button**
    $(this).closest(".popup-product-list-wrapper-with-content").find(".popup-ajax-add-to-cart").css("display","none");
    closestWrapper.find(".select-quantity").css("display","flex");

    $(".minus-quantity").css("pointer-events","auto");
    
  });
  //*** END Ajax cart click event

  // *** START Event listener for removing a product item from the sticky bundle
  $(document).on("click", ".bundle-popup-close-icon", function () {
    var removeItemVariantId = $(this).closest(".popup-product-item").attr("data-variant-id");
    removePrice($(this));
    const variantIndex = bundleVariants.findIndex((v) => v.variantID === removeItemVariantId);
    if (variantIndex !== -1) {
      bundleVariants.splice(variantIndex, 1);
    }
    console.log("bundleVariants  ",bundleVariants)
    $(this).closest("li").remove();
    updateProgressBar();
    suggestionText();
    if ($(".popup-product-item").length === 0) {
        $(".popup-edit-button").css("display", "none");
        $(".popup-next-step-button").css({"pointer-events":"none","opacity":"0.4"});
    }
    var $variant = $(".popup-ajax-add-to-cart[data-variantid='" + removeItemVariantId + "']");
    $variant.css("display", "flex");
    $variant.closest(".popup-product-list-wrapper-with-content").find(".select-quantity").css("display", "none");
    $variant.closest(".popup-product-list-wrapper-with-content").find(".select-quantity input").val(0).attr("value", 0);
    updateUI();
  });
  // *** END Event listener for removing a product item from the sticky bundle


  //************* START ajax checkout button event
  $(document).on("click", ".checkout-price", function () {
    $(this).find(".checkout-price--text").addClass("active");
    $(this).find(".loading-button").addClass("active");
    let $this = $(this)
    setTimeout(function(){
      $this.find(".checkout-price--text").removeClass("active");
      $this.find(".loading-button").removeClass("active");
    }, 2000)
    // processBundleVariants(bundleVariants, $(this));
    ajaxCheckoutJS();
  });
  //************* END ajax checkout button event
  
  //************* START popup next button click event
  // Set default progress bar values
  $(".popup-bundle-builder--main-step .PDP-last-step-progressbar").css({
    "width": "20.66%",
    "background-color": "#309388"
  });
  $(document).on("click", ".popup-next-step-button", function () {
    var dataNextStep = parseInt($(this).attr("data-next-step"), 10);
    var $popupWrapper = $(this).closest(".popup-bundle-builder-popup");
    $popupWrapper.find("[data-step='" + dataNextStep + "']").removeClass("active");
    var activeNext = dataNextStep + 1;
    $popupWrapper.find("[data-step='" + activeNext + "']").addClass("active");
    $(this).closest(".popup-bundle-builder--main-step").attr("data-active-step",activeNext);
    if ($(this).hasClass("last-step")) {
      $(".popup-bundle-builder-step--progress").hide();
    }
    $(".popup-go-back-button").css("display","flex");
    
    var stepMatch2 = $(this).closest(".popup-bundle-builder--main-step")
                          .find(".popup-append-product-choose[data-last-step='" + $(this).closest(".popup-bundle-builder--main-step").attr("data-active-step") + "']")
                          .attr("data-last-step");

    var progressWidth = stepMatch2 === '2' ? "55.66%" : (stepMatch2 === '3' ? "80.66%" : "20.66%");

    // Update the progress bar
    $(this).closest(".popup-bundle-builder--main-step").find(".PDP-last-step-progressbar").css({
      "width": progressWidth,
      "background-color": "#309388"
    });
    setTimeout(function () {
      initializeUpsellSlickSlider();
    }, 1000);
  });
  //************* END popup next button click event
  
  //************* START popup prev button click event
  $(document).on("click", ".popup-go-back-button", function () {
    var $popupWrapper = $(this).closest(".popup-bundle-builder-popup");
    var dataCurrentStep = parseInt($popupWrapper.find(".popup-data-container-step.active").attr("data-step"), 10);
    $popupWrapper.find("[data-step='" + dataCurrentStep + "']").removeClass("active");
    var dataPrevStep = dataCurrentStep - 1;
    $(this).closest(".popup-bundle-builder--main-step").attr("data-active-step",dataPrevStep)
    $popupWrapper.find("[data-step='" + dataPrevStep + "']").addClass("active");
    $(".popup-bundle-builder-step--progress").show();
    if (dataCurrentStep === 2) {
      $(this).css("display","none");
      return;
    }

    // Retrieve the 'data-last-step' attribute
    var stepMatch2 = $(this).closest(".popup-bundle-builder--main-step")
      .find(".popup-append-product-choose[data-last-step='" + dataPrevStep + "']")
      .attr("data-last-step") || '1'; // Default to '1' if undefined
  
    // Set the progress width based on stepMatch2
    var progressWidth = (stepMatch2 === '3') ? "80.66%" : 
                        (stepMatch2 === '2') ? "55.66%" : 
                        (stepMatch2 === '1') ? "20.66%" : "20.66%"; // Explicitly handle '1'

    console.log("progressWidth  ",progressWidth)
    // Update the progress bar
    $(this).closest(".popup-bundle-builder--main-step").find(".PDP-last-step-progressbar").css({
        "width": progressWidth,
        "background-color": "#309388"
    });
    setTimeout(function(){
      initializeSlickSlider();
    },700);
  });
  //************* END popup prev button click event

  //************* START 3 Edit's Step Click Event
  $(document).on("click", ".popup-edit-button, .customize-step-1, .customize-step-2", function () {
    var $popupWrapper = $(this).closest(".popup-bundle-builder-popup");
    var step = $(this).hasClass("popup-edit-button") ? 3 : $(this).hasClass("customize-step-1") ? 1 : 2;

    $popupWrapper.find(".popup-data-container-step").removeClass("active");
    var $targetStep = $popupWrapper.find(`.popup-data-container-step[data-step='${step}']`);
    $(this).closest(".popup-bundle-builder--main-step").attr("data-active-step", step);

    // Hide the "Go Back" button if step 1 is clicked
    if (step === 1) {
        $(".popup-go-back-button").css("display", "none");
    } else {
        $(".popup-go-back-button").css("display", "flex");
    }

    // Show or hide progress bar based on step
    $(".popup-bundle-builder-step--progress").toggle(step !== 3);

    if ($targetStep.length) {
        $targetStep.addClass("active");
    }
  });

  //************* END 3 Edit's Step Click Event

  //************* START Select Quantity
  $(document).on("click", ".plus-quantity", function () {
    var $input = $(this).siblings(".select-quantity input");
    var value = parseInt($input.val()) || 0;
    var newQuantity = value + 1;
    let $productPrice = $(this).attr("data-product-price");
    addPrice($(this), $productPrice);

    // **Update both value & attr("value")**
    $input.val(newQuantity).attr("value", newQuantity).trigger("change");

    const variantID = $(this).closest(".popup-product-list-wrapper-with-content").find(".popup-ajax-add-to-cart").attr("data-variantid");
    const productTitle = $(this).closest(".popup-product-list-wrapper-with-content").find(".popup-ajax-add-to-cart").attr("data-product-title");

    let existingVariant = bundleVariants.find(item => item.variantID === variantID && item.productTitle === productTitle);
    
    
    var $stickyItem = $(".popup-product-item[data-variant-id='" + variantID + "']");
    if ($stickyItem.length) {
      $stickyItem.find(".quantity-add-remove").text(newQuantity);
    }
    if (existingVariant) {
      existingVariant.quantity += 1;
      existingVariant.productTotalPrice += parseFloat($(this).attr("data-product-price")) || 0;
    }
    console.log("Updated bundleVariants:", bundleVariants);
    updateProgressBar();
  });

  $(document).on("click", ".minus-quantity", function () {
    var $input = $(this).siblings(".select-quantity input");
    var value = parseInt($input.val()) || 0;
    var newQuantity = value - 1;

    // **Update input value**
    $input.val(newQuantity).attr("value", newQuantity).trigger("change");

    const variantID = $(this).closest(".popup-product-list-wrapper-with-content").find(".popup-ajax-add-to-cart").attr("data-variantid");
    const productTitle = $(this).closest(".popup-product-list-wrapper-with-content").find(".popup-ajax-add-to-cart").attr("data-product-title");

    let existingVariant = bundleVariants.find(item => item.variantID === variantID && item.productTitle === productTitle);

    var $stickyItem = $(".popup-product-item[data-variant-id='" + variantID + "']");
    if ($stickyItem.length) {
        $stickyItem.find(".quantity-add-remove").text(newQuantity);
    }

    if (existingVariant) {
        let priceToRemove = parseFloat($(this).attr("data-product-price").replace(/[^0-9.-]+/g, "")) || 0;
        existingVariant.quantity -= 1;
        existingVariant.productTotalPrice -= priceToRemove;

        totalPrice -= priceToRemove;
        totalPrice = Math.max(totalPrice, 0); // **Ensure totalPrice doesn't go negative**

        // **Update UI elements**
        $("#popup-current-amount").text(dataCurrency + totalPrice.toFixed(2));
        $(".popup-total-price").text(dataCurrency + totalPrice.toFixed(2));
        $(".checkout-button-price").text(dataCurrency + totalPrice.toFixed(2));

        updateUI();

        // **Remove item if quantity reaches 0**
        if (existingVariant.quantity <= 0) {
          bundleVariants = bundleVariants.filter(item => !(item.variantID === variantID && item.productTitle === productTitle));

          if ($stickyItem.length) {
              $stickyItem.find(".sticky-item-close-icon").trigger("click");
              $stickyItem.closest("li").remove();
          }

          // **Reset UI when item is removed**
          $input.val(0).attr("value", 0);
          $(this).css("pointer-events", "none");

          setTimeout(() => {
              $(this).closest(".select-quantity").hide();
          }, 50);

          $(this).closest(".popup-product-list-wrapper-with-content").find(".popup-ajax-add-to-cart").show();
          suggestionText();
        }
    }

    // **Update progress bar**
    updateProgressBar();
  });


  
  //************* END Select Quantity

  // function updateProgressBar(step) {
  //   var progressWidth = step === '2' ? "55.66%" : (step === '3' ? "80.66%" : "20.66%");
    
  //   $(this).closest(".popup-bundle-builder--main-step").find(".PDP-last-step-progressbar").css({
  //     "width": progressWidth,
  //     "background-color": "#309388"
  //   });
  // }

  //************* START Suggestion text
  // function suggestionText() {
  //   let suggestion = "Suggestion: Add 2 Bijou Haven in your cart";

  //   // Define keyword pairs and corresponding suggestions
  //   const keywordPairs = [
  //       { keywords: ["mainstay", "swing arm"], suggestion: "Suggestion: Add 1 Sway swing and 1 Skate swing" },
  //       { keywords: ["mainstay", "rope bridge"], suggestion: "Suggestion: Add a second Mainstay" },
  //       { keywords: ["mainstay"], suggestion: "Suggestion: Add 1 Next Level" },
  //       { keywords: ["rope bridge"], suggestion: "Suggestion: Add 1 Bijou Pocket" },
  //       { keywords: ["haven"], suggestion: "Suggestion: Add 1 Hover swing" }
  //   ];

  //   // Loop through each keyword pair
  //   for (const pair of keywordPairs) {
  //       const match = pair.keywords.every(keyword => {
  //           return bundleVariants.some(item => 
  //               item.productTitle.toLowerCase().includes(keyword.toLowerCase())
  //           );
  //       });

  //       // If a match is found, update the suggestion and break the loop
  //       if (match) {
  //           suggestion = pair.suggestion;
  //           break;
  //       }
  //   }

  //   // Display the final suggestion on the page
  //   $("#popup-suggestion").html(suggestion);
  //   return suggestion;
  // }
  function suggestionText() {
    let suggestion = "Suggestion: Add 2 Bijou Haven in your cart";
    const allTitles = bundleVariants.map(item => item.productTitle.toLowerCase().trim().replace(/\s+/g, " "));
    // Define keyword pairs and corresponding suggestions
    const keywordPairs = [
        { keywords: ["mainstay", "swing arm"], suggestion: "Suggestion: Add 1 Sway swing and 1 Skate swing" },
        { keywords: ["mainstay", "rope bridge"], suggestion: "Suggestion: Add a second Mainstay" },
        { keywords: ["rope bridge"], suggestion: "Suggestion: Add 1 Bijou Pocket" },
        { keywords: ["haven"], suggestion: "Suggestion: Add 1 Hover swing" },
        { keywords: ["mainstay"], suggestion: "Suggestion: Add 1 Next Level" }
    ];
    
    // Check for matching keyword pairs in allTitles
    for (const pair of keywordPairs) {
      const { keywords, suggestion: pairSuggestion } = pair;
      const match = keywords.every(keyword => allTitles.some(title => title.includes(keyword.toLowerCase())));
      if (match) {
          suggestion = pairSuggestion;
          // $("#suggestion").text(suggestion);
          break;
      }
     }
    $("#popup-suggestion").html(suggestion);
    return suggestion;
  }
  //************* END Suggestion text

  function chooseAjaxCheckoutJS(chooseVariantId) {
    const payload = {
      items: [{
        id: parseInt(chooseVariantId, 10), // Use the passed variant ID
        quantity: 1, // Default to 1 if quantity is not provided
      }],
    };

    // Send the POST request
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add products to the cart");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Products added to the cart:", data);
      })
      .catch((error) => {
        console.error("Error adding products to the cart:", error);
      });
  }
  //************* START Choose section add to cart js
  $(document).on("click",".view-button",function(){
    var chooseVariantId = $(this).attr("data-variantid");
    $(this).find("button").addClass("active");
    $(this).find(".loading-button").addClass("active");
    let $this = $(this)
    setTimeout(function(){
      $this.find("button").removeClass("active");
      $this.find(".loading-button").removeClass("active");
    }, 200)
    chooseAjaxCheckoutJS(chooseVariantId);
  });
  //************* END Choose section add to cart js
  // popup scroll add remove class
  $(".bundle-builder-popup-wrapper").on("scroll", function () {
    var $popupWrapper = $(this);
    var progressBar = $popupWrapper.find(".popup-bundle-builder-step--progress");
    var bundleDiv = $popupWrapper.find(".bundle-popup-inner-div");

    if (progressBar.length && bundleDiv.length) {
        var progressTop = progressBar.position().top;
        var scrollTop = $popupWrapper.scrollTop();

        if (scrollTop >= progressTop) {
            bundleDiv.addClass("active");
        } else {
            bundleDiv.removeClass("active");
        }
    }
  });
  
  // discount price updated
  function updateTotalPrice() {
    // Apply discount based on totalPrice and update the UI
    let finalPrice = totalPrice;
    let isDiscountApplied = false;

    // Apply discount before updating the UI
    if (totalPrice >= 1000) {
      finalPrice = applyDiscount(totalPrice); // Apply the discount
      isDiscountApplied = true;
    }

    $("#popup-current-amount").text(dataCurrency + finalPrice.toFixed(2));
    $(".sticky-bundle-wrapper-content-discount-price").text(dataCurrency + finalPrice.toFixed(2));
    $(".checkout-button-price").text(dataCurrency + finalPrice.toFixed(2));

    if (isDiscountApplied) {
      $(".sticky-bundle-wrapper-content-discount-price").css("display", "block");
      $(".sticky-apply-discount-wrapper").addClass("active");  
    } else {
      $(".sticky-bundle-wrapper-content-discount-price").css("display", "none");
      $(".sticky-apply-discount-wrapper").removeClass("active");  
    }
  }
  
  // Function to apply the discount based on price
  function applyDiscount(price) {
    if (price >= 1000 && price < 1500) {
        return price * 0.95; // 5% discount for prices between 1000 and 1499
    } else if (price >= 1500 && price < 2000) {
        return price * 0.9; // 10% discount for prices between 1500 and 1999
    } else if (price >= 2000) {
        return price * 0.85; // 15% discount for prices 2000 or more
    }
    return price; // No discount if less than 1000
  }

  function updateUI() {
    let finalPrice = applyDiscount(totalPrice); // Apply discount based on the updated totalPrice

    $("#popup-current-amount").text(dataCurrency + totalPrice.toFixed(2));
    $(".popup-total-price").text(dataCurrency + totalPrice.toFixed(2));
    $(".sticky-bundle-wrapper-content-discount-price").text(dataCurrency + totalPrice.toFixed(2));
    $(".checkout-button-price").text(dataCurrency + finalPrice.toFixed(2));


    console.log("Updated totalPrice:", totalPrice);
    updateTotalPrice();
  }


})